import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import styles from './LastMinuteBackupModal.module.scss';

const LastMinuteBackupModalContent = () => (
  <div className={styles['last-minute-backup-modal__body']}>
    <p>{trans('last.minute.backup.modal.description')}</p>

    <div>
      <h5 className={styles['last-minute-backup-modal__conditions-title']}>
        {trans('last.minute.backup.modal.conditions1')}
      </h5>
      <ul className={styles['last-minute-backup-modal__conditions-list']}>
        <li>{trans('last.minute.backup.modal.conditions1.item1')}</li>
        <li>{trans('last.minute.backup.modal.conditions1.item2')}</li>
        <li>{trans('last.minute.backup.modal.conditions1.item3')}</li>
      </ul>
    </div>

    <div>
      <h5 className={styles['last-minute-backup-modal__conditions-title']}>
        {trans('last.minute.backup.modal.conditions2')}
      </h5>
      <p>{trans('last.minute.backup.modal.conditions2.item1')}</p>
    </div>
  </div>
);

const openLastMinuteBackupModal = () => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: (
      <>
        <DSIcon name="support" size="ml" />
        <br />
        {trans('last.minute.backup.modal.title')}
      </>
    ),
    body: <LastMinuteBackupModalContent />,
    fullscreenOnMobile: true
  });
};

export default openLastMinuteBackupModal;
